<template>
    <div v-if="history.length > 0" class="add-rule__footer" style="margin-top: 300px;">
        <div class="">
            <div class="add-rule__info">
                <tooltip
                        :direction="'bottom-left-direction'"
                        :add-class-wrap="'tooltip-log'"
                        :isBtnClose="false"
                        :add-style="{width: 360 + 'px'}"
                        @tooltipshow="logActive = true"
                        @tooltipclose="logActive = false">
                    <span slot="tooltipBtn" class="i i-info4 mr4" :class="{active: logActive}">
                    </span>

                    <div slot="tooltipContent">
                        <div class="text-size-s text-bold">
                            История
                        </div>
                        <div class="mt8" v-for="row in history">
                            <span>{{ row.event }} {{ row.date }}, {{ row.time }}</span>
                            <span class="ml4 mr4">|</span>
                            <span>{{ row.user }}</span>
                        </div>
                    </div>
                </tooltip>
                <span>{{ historyLast.event }} {{ historyLast.date }}, {{ historyLast.time }}</span>
                <span class="ml4 mr4">|</span>
                <span> {{ historyLast.user }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import Tooltip from '@/components/Tooltip.vue';

export default {
    name: "History",
    components: {
        Tooltip
    },
    props: {
        contractDetail: {}
    },
    data(){
        return {
            logActive: false,
            history: []
        }
    },
    computed: {
        historyLast() {
            let history = [];

            if (typeof this.history !== 'undefined' && this.history.length) {
                history = this.history.slice(-1).pop();
            }

            return history;
        },
    },
    mounted() {
        this.$store.dispatch('contracts/getItemHistory',{id:this.contractDetail.id}).then((items)=>{
            this.history = items;
        })
    }
}
</script>

<style scoped>

</style>
